import {useState} from 'react';
import { useTranslation } from 'react-i18next';
import Icon1 from 'img/shortcut/icon1.svg';
import Icon2 from 'img/shortcut/icon2.svg';
import Icon3 from 'img/shortcut/icon3.svg';
import './index.css';


const Shortcut = () => {
  const { t } = useTranslation();
  const [enteryType, setEnteryType] = useState([
    {"icon": Icon1, text: t('shortcut.text1')},
    {"icon": Icon2, text: t('shortcut.text2')},
    {"icon": Icon3, text: t('shortcut.text3')},
  ]);
  const Add = enteryType.map(Add => Add) || setEnteryType.map(Add => Add);
  return(
    <div className="shortcutBox">
      {Add.map((enteryType, key) => <a key={key}><img src={enteryType.icon} alt="" /><p>{enteryType.text}</p></a>)}
    </div>
  )
}

export default Shortcut
